"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TeamsIntegrationModal", {
  enumerable: true,
  get: function get() {
    return _TeamsIntegrationModal.TeamsIntegrationModal;
  }
});
var _TeamsIntegrationModal = require("./TeamsIntegrationModal");